<!-- TODO 作成中、適切な制御がまだできていない -->
<template>
  <div>
    <v-row dense>
      <v-col class="caption search-item-caption">
        {{ title }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3" class="year-input">
        <template v-if="veeValidate">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: this.validation }"
          >
            <v-text-field
              v-model="date"
              :placeholder="
                disabled
                  ? config.PLACEHOLDER_SP
                  : config.PLACEHOLDER_SELECT_DATE
              "
              label="年月日"
              readonly
              @click:clear="clearDate"
              v-bind="formControlProps"
              :error-messages="errors"
            >
              <template v-slot:append v-if="!disabled">
                <date-picker
                  v-model="selectedDate"
                  @input="inputDate($event)"
                  :min="min"
                  :max="max"
                />
              </template>
            </v-text-field>
          </validation-provider>
        </template>
        <template v-else>
          <!-- 上記v-text-fieldを修正した場合、こちらも同様に修正すること（※error-messages以外） -->
          <v-text-field
            v-model="date"
            :placeholder="
              disabled ? config.PLACEHOLDER_SP : config.PLACEHOLDER_SELECT_DATE
            "
            label="年月日"
            readonly
            @click:clear="clearDate"
            v-bind="formControlProps"
            :error-messages="dateErrorMessage()"
          >
            <template v-slot:append v-if="!disabled">
              <date-picker
                v-model="selectedDate"
                @input="inputDate($event)"
                :min="min"
                :max="max"
              />
            </template>
          </v-text-field>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="2" class="hour-input">
        <template v-if="veeValidate">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: this.validation }"
          >
            <v-combobox
              v-model="hour"
              :items="hours"
              ref="hour"
              label="時"
              :placeholder="config.PLACEHOLDER_SP"
              v-bind="formControlProps"
              @input="hour = inputHour($event)"
              @keypress="keyPressHour($event)"
              @blur="blurHour($event)"
              @keyup="keyUpHour($event)"
              @click:clear="minute = null"
              maxlength="2"
              type="tel"
              :error-messages="errors"
            >
            </v-combobox>
          </validation-provider>
        </template>
        <template v-else>
          <!-- 上記v-comboboxを修正した場合、こちらも同様に修正すること（※error-messages以外） -->
          <v-combobox
            v-model="hour"
            :items="hours"
            ref="hour"
            label="時"
            :placeholder="config.PLACEHOLDER_SP"
            v-bind="formControlProps"
            @input="hour = inputHour($event)"
            @keypress="keyPressHour($event)"
            @blur="blurHour($event)"
            @keyup="keyUpHour($event)"
            @click:clear="minute = null"
            maxlength="2"
            type="tel"
            :error-messages="hourErrorMessage()"
          >
          </v-combobox>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="2" v-if="isDisplayTime">
        <template v-if="veeValidate">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: this.validation }"
          >
            <v-combobox
              v-model="minute"
              :items="minutes"
              ref="minute"
              label="分"
              :placeholder="config.PLACEHOLDER_SP"
              v-bind="formControlProps"
              @input="minute = inputMinute($event)"
              @keypress="keyPressMinute($event)"
              @blur="blurMinute($event)"
              @keyup="keyUpMinute($event)"
              maxlength="2"
              type="tel"
              :error-messages="errors"
            >
            </v-combobox>
          </validation-provider>
        </template>
        <template v-else>
          <!-- 上記v-comboboxを修正した場合、こちらも同様に修正すること（※error-messages以外） -->
          <v-combobox
            v-model="minute"
            :items="minutes"
            ref="minute"
            label="分"
            :placeholder="config.PLACEHOLDER_SP"
            v-bind="formControlProps"
            @input="minute = inputMinute($event)"
            @keypress="keyPressMinute($event)"
            @blur="blurMinute($event)"
            @keyup="keyUpMinute($event)"
            maxlength="2"
            type="tel"
            :error-messages="minuteErrorMessage()"
          >
          </v-combobox>
        </template>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="2"
        lg="2"
        v-if="withoutNow !== true && !disabled"
      >
        <v-btn class="mx-2 mt-4 ml-0" color="primary" small @click="now">
          現在時刻
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import config from "@/js/const";
import DatePicker from "@/components/DatePicker";
import DateUtils from "@/plugins/date-utils";
import FormUtils from "@/plugins/form-utils";
import { extend, ValidationProvider, setInteractionMode } from "vee-validate";
import { required } from "vee-validate/dist/rules";

Vue.use(DateUtils);
Vue.use(FormUtils);

setInteractionMode("eager");
extend("required", {
  ...required,
  message: "必須項目です。"
});

const TIME_FROM = Object.freeze({
  hour: "00",
  minute: "00",
  second: "00"
});

const TIME_TO = Object.freeze({
  hour: "23",
  minute: "59",
  second: "59"
});

export default {
  name: "DatetimePicker",

  props: {
    title: {
      type: String
    },
    datetime: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    withoutNow: {
      type: Boolean
    },
    selectedDatetime: {
      type: String
    },
    isTo: {
      type: Boolean
    },
    isSearch: {
      type: Boolean
    },
    min: {
      type: String,
      required: false,
      default: null
    },
    max: {
      type: String,
      required: false,
      default: null
    },
    validation: {
      type: Boolean
    },
    isClearWhenInit: {
      type: Boolean
    },
    isNotBlank: {
      type: Object,
      default: () => ({ date: false, hour: false, minute: false })
    },
    // veeValidateを使用するか否か
    veeValidate: {
      type: Boolean,
      default: true
    },
    // veeValidateがfalseの場合に使用
    // 年月日時分すべて設定、またはすべて未設定の場合、true、それ以外はfalse
    validDatetime: {
      type: Boolean
    },
    // 日時表示有無
    isDisplayTime: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    config: config,
    minutes: [],
    hours: [],
    selectedDate: "",
    hour: "",
    minute: "",
    defaultTime: cloneDeep(TIME_FROM)
  }),
  components: {
    DatePicker,
    ValidationProvider
  },
  watch: {
    max(val) {
      this.hours = this.$dateUtils.getHours();
      this.minutes = this.$dateUtils.getMinutes();
      const maxDate = new Date(val);
      const d = this.selectedDate;
      const selectedDate = new Date(d);
      if (
        selectedDate.getFullYear() === maxDate.getFullYear() &&
        selectedDate.getMonth() === maxDate.getMonth() &&
        selectedDate.getDate() === maxDate.getDate()
      ) {
        const maxHour = maxDate.getHours();
        this.hours = this.hours.filter(h => parseInt(h.value) <= maxHour);
        const hour = this.hour;
        if (hour > maxHour) this.hour = (maxHour + "").padStart(2, "0");

        if (parseInt(this.hour) === parseInt(maxHour)) {
          const maxMinutes = maxDate.getMinutes();
          this.minutes = this.minutes.filter(
            m => parseInt(m.value) <= maxMinutes
          );
          const minute = this.minute;
          if (minute > maxMinutes)
            this.minute = (maxMinutes + "").padStart(2, "0");
        }
        // const minute = this.minute;
        // const date = new Date(`${d} ${hour}:${minute}`);
      }
    },
    min(val) {
      this.hours = this.$dateUtils.getHours();
      this.minutes = this.$dateUtils.getMinutes();
      const minDate = new Date(val);
      const d = this.selectedDate;
      const selectedDate = new Date(d);
      if (
        selectedDate.getFullYear() === minDate.getFullYear() &&
        selectedDate.getMonth() === minDate.getMonth() &&
        selectedDate.getDate() === minDate.getDate()
      ) {
        const minHour = minDate.getHours();
        this.hours = this.hours.filter(h => parseInt(h.value) >= minHour);
        const hour = this.hour;
        if (hour > minHour) this.hour = (minHour + "").padStart(2, "0");

        if (parseInt(this.hour) === parseInt(minHour)) {
          const minMinutes = minDate.getMinutes();
          this.minutes = this.minutes.filter(
            m => parseInt(m.value) >= minMinutes
          );
          const minute = this.minute;
          if (minute > minMinutes)
            this.minute = (minMinutes + "").padStart(2, "0");
        }
        // const minute = this.minute;
        // const date = new Date(`${d} ${hour}:${minute}`);
      }
    },
    selectedDate: {
      handler: function(value) {
        Object.assign(this.isNotBlank, { date: !!value });
        this.$emit("update:isNotBlank", this.isNotBlank);
      }
    },
    hour: {
      handler: function(value) {
        Object.assign(this.isNotBlank, { hour: !!value });
        this.$emit("update:isNotBlank", this.isNotBlank);
      }
    },
    minute: {
      handler: function(value) {
        Object.assign(this.isNotBlank, { minute: !!value });
        this.$emit("update:isNotBlank", this.isNotBlank);
      }
    },
    selectedDatetime: "initialize"
  },

  mounted() {
    this.initialize();
  },

  computed: {
    date: {
      get: function() {
        return this.$dateUtils.toHyphenFromSlash(this.selectedDate);
      },
      set: function() {}
    },
    formControlProps() {
      return this.$formControlProps(this.disabled);
    }
  },

  methods: {
    initialize() {
      this.minutes = this.$dateUtils.getMinutes();
      this.hours = this.$dateUtils.getHours();
      if (this.isTo) {
        this.defaultTime = cloneDeep(TIME_TO);
      }
      if (this.isClearWhenInit) {
        this.selectedDate = null;
        this.hour = null;
        this.minute = null;
      }
      if (typeof this.datetime !== "undefined") {
        const datetime = this.$dateUtils.splitDatetime(this.datetime);
        if (datetime !== null) {
          this.selectedDate = datetime.date;
          this.hour = datetime.hour;
          this.minute = datetime.minute;
        }
      }
    },

    now() {
      const formattedNow = this.$dateUtils.formattedNow();
      const datetime = this.$dateUtils.splitDatetime(formattedNow);
      this.selectedDate = datetime.date;
      this.hour = datetime.hour;
      this.minute = datetime.minute;
      const second = this.isSearch ? this.defaultTime.second : "00";
      this.updateSelectedDatetime(
        `${datetime.date} ${datetime.hour}:${datetime.minute}:${second}`
      );
      Object.assign(this.isNotBlank, { date: true, hour: true, minute: true });
      this.$emit("update:isNotBlank", this.isNotBlank);
    },

    inputDate(value) {
      this.updateDatetime(value, "date");
    },

    keyPressHour(e) {
      const keyCode = e.keyCode;
      let str = String.fromCharCode(keyCode);
      if (!str.match(/[0-9]/)) {
        e.preventDefault();
        return false;
      }
    },

    blurHour(e) {
      this.keyUpHour(e);
    },

    keyUpHour(e) {
      e.target.value = e.target.value.replace(/[^0-9]+/i, "");
    },

    inputHour(value) {
      setTimeout(() => {
        if (!value) return "";
        const targetValue = typeof value === "object" ? value.value : value;
        const hasHour = this.hours.some(hour => {
          return hour.value === targetValue;
        });
        if (hasHour) {
          this.hour = targetValue;
        } else {
          this.hour = null;
          this.minute = null;
        }
        this.updateDatetime(targetValue, "hour");
        this.$refs.hour.blur();
      }, 0);
      return this.hour;
    },

    keyPressMinute(e) {
      this.keyPressHour(e);
    },

    blurMinute(e) {
      this.blurHour(e);
    },

    keyUpMinute(e) {
      this.keyUpHour(e);
    },

    inputMinute(value) {
      setTimeout(() => {
        if (!value) return "";
        const targetValue = typeof value === "object" ? value.value : value;
        const hasMinute = this.minutes.some(minute => {
          return minute.value === targetValue;
        });
        if (hasMinute) {
          this.minute = targetValue;
        } else {
          this.minute = null;
        }
        this.updateDatetime(targetValue, "minute");
        this.$refs.minute.blur();
      }, 0);
      return this.minute;
    },

    updateDatetime(value, type) {
      if (!this.date) {
        this.clearSelectedDatetime();
        return;
      }
      const date = this.date;
      const second = this.defaultTime.second;
      let hour = this.hour;
      let minute = this.minute;
      if (type === "date") {
        if (typeof value === "undefined" || value === null || value === "") {
          this.clearSelectedDatetime();
          return;
        }

        if (
          typeof this.hour === "undefined" ||
          this.hour === null ||
          this.hour === ""
        ) {
          hour = this.defaultTime.hour;
          minute = this.defaultTime.minute;
        }
        if (
          typeof this.minute === "undefined" ||
          this.minute === null ||
          this.minute === ""
        ) {
          minute = this.defaultTime.minute;
        } else {
          minute = this.minute;
        }
      } else if (type === "hour") {
        if (typeof value === "undefined" || value === null || value === "") {
          hour = this.defaultTime.hour;
          minute = this.defaultTime.minute;
        } else {
          hour = value;
          if (
            typeof this.minute === "undefined" ||
            this.minute === null ||
            this.minute === ""
          ) {
            minute = this.defaultTime.minute;
          } else {
            minute = this.minute;
          }
        }
      } else if (type === "minute") {
        if (typeof value === "undefined" || value === null || value === "") {
          minute = this.defaultTime.minute;
        } else {
          if (
            typeof this.hour === "undefined" ||
            this.hour === null ||
            this.hour === ""
          ) {
            hour = this.defaultTime.hour;
            minute = this.defaultTime.minute;
          } else {
            hour = this.hour;
            minute = value;
          }
        }
      } else {
        throw new Error(`引数不正[type:${type}]`);
      }
      this.updateSelectedDatetime(`${date} ${hour}:${minute}:${second}`);
    },
    clearDate() {
      this.selectedDate = null;
      this.hour = null;
      this.minute = null;
      this.clearSelectedDatetime();
    },
    clearSelectedDatetime() {
      this.updateSelectedDatetime(null);
    },
    updateSelectedDatetime(datetime) {
      this.$emit("update:selectedDatetime", datetime);
    },
    /**
     * VeeValidateを使用しないことが条件
     * 時間、分のいずれかが選択されており、日付が未選択の場合のエラーメッセージを取得する
     * ※validDatetimeの更新も行う
     * @returns {string}
     */
    dateErrorMessage() {
      if (this.veeValidate) {
        return "";
      }
      this.$emit("update:validDatetime", this.validateDatetime());
      if (!this.date && (this.hour || this.minute)) {
        return "日付を選択してください。";
      }
      return "";
    },
    /**
     * VeeValidateを使用しないことが条件
     * 日付、分のいずれかが選択されており、時間が未選択の場合のエラーメッセージを取得する
     * ※validDatetimeの更新も行う
     * @returns {string}
     */
    hourErrorMessage() {
      if (this.veeValidate) {
        return "";
      }
      this.$emit("update:validDatetime", this.validateDatetime());
      if (!this.hour && (this.date || this.minute)) {
        return "時間を選択してください。";
      }
      return "";
    },
    /**
     * VeeValidateを使用しないことが条件
     * 日付、時間のいずれかが選択されており、分が未選択の場合のエラーメッセージを取得する
     * ※validDatetimeの更新も行う
     * @returns {string}
     */
    minuteErrorMessage() {
      if (this.veeValidate) {
        return "";
      }
      this.$emit("update:validDatetime", this.validateDatetime());
      if (!this.minute && (this.date || this.hour)) {
        return "時間を選択してください。";
      }
      return "";
    },
    /**
     * VeeValidateを使用しないことが条件(VeeValidateを使用する場合は常にtrue)
     * 年月日時分すべて設定、またはすべて未設定の場合、true、それ以外はfalse
     * @returns {boolean}
     */
    validateDatetime() {
      if (this.veeValidate) {
        return true;
      }
      if (this.hour && this.date && this.minute) {
        return true;
      }
      return !this.hour && !this.date && !this.minute;
    }
  }
};
</script>
